import './index.css'

const Footer = () => (
    <footer className="footer">
        <div className="container">
            <p className="footer__text">
                built by{'  '}
                <a href="https://github.com/Ciphercrypt" target="_blank" rel="noreferrer">
                    avishkar mohite
                </a>
            </p>
            <p className="footer__sub">
                avishkar.mohite.eng@gmail.com · Pune, India
            </p>
        </div>
    </footer>
)

export default Footer
